(function () {
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('cart.js failed');
    return r.json();
  }

  async function updateAllBars() {
    const bars = document.querySelectorAll('.icart-fsb');
    if (!bars.length) return;

    let cart;
    try {
      cart = await getCart();
    } catch (e) {
      // Si falla, no rompas la UI; deja el texto por defecto
      return;
    }

    const currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      cart.currency ||
      'CAD';

    const subtotal = (cart.items_subtotal_price ?? cart.total_price ?? 0); // cents

    bars.forEach((bar) => {
      const goalCad = parseFloat(bar.getAttribute('data-goal-cad') || '100');
      const goalCents = Math.round(goalCad * 100);

      const remaining = goalCents - subtotal;
      const progress = Math.max(0, Math.min(100, (subtotal / goalCents) * 100));

      const textEl = bar.querySelector('.icart-fsb__text');
      const fillEl = bar.querySelector('.icart-fsb__fill');

      if (fillEl) fillEl.style.width = progress.toFixed(0) + '%';

      if (!textEl) return;

      if (remaining > 0) {
        textEl.textContent = `Add ${money(remaining, currency)} more to unlock FREE shipping!`;
      } else {
        textEl.textContent = `🎉 You unlocked FREE shipping!`;
      }
    });
  }

  // 1) Primera carga
  document.addEventListener('DOMContentLoaded', updateAllBars);

  // 2) iCart suele re-renderizar el drawer; usa MutationObserver para actualizar al aparecer/cambiar
  const obs = new MutationObserver(() => {
    // throttle simple
    clearTimeout(window.__icartFsbT);
    window.__icartFsbT = setTimeout(updateAllBars, 150);
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });

  // 3) Fallback cada 2s mientras exista el drawer (por si el observer no capta algún update)
  setInterval(updateAllBars, 2000);
})();
